import { Theme } from "@mui/material/styles";
import { alpha } from "@mui/material";

// The backend stores messages as rendered email HTML. message-base.html.twig wraps
// each message in a div whose direct child is the presentation table. Some inquiry
// messages contain another fully rendered message inside the outer message, so this
// selector deliberately matches layout wrappers at every nesting level.
const messageLayoutSelector = "& div:has(> table[role='presentation'])";
const messageLayoutTableSelector = `${messageLayoutSelector} > table[role='presentation']`;

const messageCenterMessageStyle = {
  messageContainer: {
    color: "black",
  },
  dateRow: {
    display: "flex",
    justifyContent: "flex-end",
    marginBottom: "0.5rem",
  },
  sender: {
    color: "primary.main",
  },
  messageBubble: {
    padding: "1rem",
    hyphens: "auto",
  },
  ownMessageText: (theme: Theme) => ({
    overflowWrap: "break-word",
    margin: "2rem 0",
    maxWidth: "100%",
    overflowX: "auto",
    [messageLayoutSelector]: {
      maxWidth: "none !important",
      width: "100% !important",
    },
    [messageLayoutTableSelector]: {
      width: "100% !important",
    },
    "& p, & li, & th, & td, & h1, & h2, & h3, & h4, & h5, & h6": {
      color: `${theme.palette.text.primary} !important`,
    },
    "& p, & ul, & ol": {
      marginTop: "0rem !important",
      marginBottom: {
        xs: "0.75rem !important",
        md: "1rem !important",
      },
    },
    "& h1, & h2, & h3, & h4, & h5, & h6": {
      marginTop: "0rem !important",
      marginBottom: {
        xs: "1rem !important",
        md: "1.25rem !important",
      },
    },
    "& ul, & ol": {
      paddingLeft: {
        xs: "1.25rem !important",
        md: "1.5rem !important",
      },
    },
    "& table": {
      maxWidth: "100% !important",
    },
    "& table:not([role='presentation'])": {
      width: "100% !important",
    },
    "& th, & td": {
      overflowWrap: "anywhere",
    },
    "& img": {
      maxWidth: "100% !important",
      height: "auto !important",
    },
  }),
  ownMessageBubble: (theme: Theme) => ({
    marginLeft: "10%",
    backgroundColor: alpha(theme.palette.primaryPale, 0.75),
  }),
  otherMessageBubble: (theme: Theme) => ({
    backgroundColor: alpha(theme.palette.primaryPale, 0.25),
  }),
  attachmentDivider: {
    marginBottom: "1rem",
  },
  attachmentGrid: {
    justifyContent: "flex-start",
  },
  customerFeedbackBox: {
    padding: "1rem 0.25rem",
  },
  feedbackRow: {
    alignItems: {
      md: "center",
    },
    minHeight: {
      md: "3rem", // Button height to prevent content jumping
    },
  },
  ratingContainer: {
    paddingTop: {
      xs: "0.5rem",
      md: "0rem",
    },
  },
  rating: {
    // Hide MUI's empty radio option so only actual star ratings are available.
    '& input[value=""]': {
      display: "none",
    },
  },
  submitFeedbackButton: (theme: Theme) => ({
    [theme.breakpoints.down("md")]: {
      paddingLeft: "0rem",
    },
  }),
};
export default messageCenterMessageStyle;
